angular.module('app').factory('SessionService',
    [
        '$rootScope',

        function($rootScope) {
            'use strict';

            var sessionParams = {
                PatientAuthenticated: false,
                PracticeConsentAccepted: false,
                DisplayDashboardToolbar: false,
                ShowHeaderNavigationMenu: false,
                NewPasswordRequired: false,
                ShowMobileNav: false
            };

            function setNewPasswordRequired (value){
                sessionParams.NewPasswordRequired = value;
            }

            function getNewPasswordRequired() {
                return sessionParams.NewPasswordRequired;
            }


            var resetSessionParams = function (sessionsParams) {
                sessionsParams.NewPasswordRequired = false;
            };

            var setShowMobileNav = function (value){
                sessionParams.ShowMobileNav = value;
                $rootScope.$broadcast('ShowMobileNav:updated', sessionParams.ShowMobileNav);
            };
            var getShowMobileNav = function (){
                return sessionParams.ShowMobileNav;
            };

            return {
                resetSessionParams: resetSessionParams,
                getNewPasswordRequired: getNewPasswordRequired,
                setNewPasswordRequired: setNewPasswordRequired,
                setShowMobileNav : setShowMobileNav,
                getShowMobileNav : getShowMobileNav
            };
        }
    ]);